import type { default as MediaListJson } from "entity/media/common/MediaList.api.json";

type MediaListEntityApiData = typeof MediaListJson;
type BTViewingPermissionsApiData = MediaListEntityApiData["files"][number]["viewPermissions"];
type BTFilePermissionsApiData = MediaListEntityApiData["files"][number]["permissions"];

export class BTViewingPermissions {
    constructor(data: BTViewingPermissionsApiData) {
        this.showSubs = data.showSubs;
        this.showAllSubs = data.showAllSubs;
        this.showOwner = data.showOwner;
        this.mainFile = data.mainFile;
    }

    showSubs: boolean;
    showAllSubs: boolean;
    showOwner: boolean;
    mainFile: boolean;
}

export class BTFilePermissions {
    /*
    ToDo: Refactor to drop the optional parameter and the nullish coalescing operator
    This was added in order to avoid breaking changes as this object was added to a new API
    with the frontend changes in the same pull request
    Ex:
    constructor(data: BTFilePermissionsApiData) {
        this.canAddRfis = data.canAddRfis;
        ..........
    }
    */
    constructor(data?: BTFilePermissionsApiData) {
        this.canAddRfis = data?.canAddRfis ?? false;
        this.canAnnotate = data?.canAnnotate ?? false;
        this.canComment = data?.canComment ?? false;
        this.canAdd = data?.canAdd ?? false;
        this.canCopy = data?.canCopy ?? false;
        this.canDelete = data?.canDelete ?? false;
        this.canDrawOnline = data?.canDrawOnline ?? false;
        this.canEdit = data?.canEdit ?? false;
        this.canEditOnline = data?.canEditOnline ?? false;
        this.canMove = data?.canMove ?? false;
        this.canRequestSignatures = data?.canRequestSignatures ?? false;
        this.canSetAsOwnerFeature = data?.canSetAsOwnerFeature ?? false;
        this.canSetViewingPermissions = data?.canSetViewingPermissions ?? false;
        this.canSign = data?.canSign ?? false;
        this.canViewRfis = data?.canViewRfis ?? false;
        this.canEditDailyLogs = data?.canEditDailyLogs ?? false;
        this.canEditToDos = data?.canEditToDos ?? false;
        this.canEditScheduleItems = data?.canEditScheduleItems ?? false;
        this.canEditChangeOrders = data?.canEditChangeOrders ?? false;
        this.canEditWarranties = data?.canEditWarranties ?? false;
        this.canEditSelections = data?.canEditSelections ?? false;
        this.canEditBids = data?.canEditBids ?? false;
        this.canEmail = data?.canEmail ?? false;
    }

    canAddRfis: boolean;
    canAnnotate: boolean;
    canComment: boolean;
    canAdd: boolean;
    canCopy: boolean;
    canDelete: boolean;
    canDrawOnline: boolean;
    canEdit: boolean;
    canEditOnline: boolean;
    canMove: boolean;
    canRequestSignatures: boolean;
    canSetAsOwnerFeature: boolean;
    canSetViewingPermissions: boolean;
    canSign: boolean;
    canViewRfis: boolean;
    canEditDailyLogs: boolean;
    canEditToDos: boolean;
    canEditScheduleItems: boolean;
    canEditChangeOrders: boolean;
    canEditWarranties: boolean;
    canEditSelections: boolean;
    canEditBids?: boolean;
    canEmail: boolean;
}
